import tw, { styled } from "twin.macro";

export const SubTitle = styled.p`
  color: #505d68;
  font-size: 11px;
  margin-top: 20px;
  max-width: 405px;
`;

export const SecondIpLabel = tw.span`text-black-50`;
export const FieldSeparator = tw.div`mt-1`;
export const SoftLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  color: rgba(66, 75, 90, 0.7);
`;
